import { httpV2 } from '@/bundles/Http/factory/httpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { RecordMapper } from '@/bundles/App/models/RecordMapper';
import LeaseIngestionService from '@/bundles/LeaseIngestion/services/LeaseIngestionService';
import LeaseIngestion from '@/bundles/LeaseIngestion/models/LeaseIngestion';
import { ILeaseIngestion } from '@/bundles/LeaseIngestion/types';

function leaseIngestionServiceFactory () {
  return new LeaseIngestionService(
    httpV2,
    new ErrorMapper(),
    new RecordMapper<ILeaseIngestion>(LeaseIngestion),
  );
}

export const leaseIngestionService = leaseIngestionServiceFactory();
